<template>
  <van-list
    v-model="isLoading"
    :finished="isFinish"
    :error.sync="isError"
    :error-text="errorText"
    :finished-text="finishedText"
    @load="request(pageNum+1)"
  >
    <slot :list="list">
    </slot>
  </van-list>
</template>

<script>
import { List } from 'vant';
import STATUS from '@/constants/status';

export default {
  name: 'LongList',
  components: {
    [List.name]: List,
  },
  props: {
    /**
     * 请求api函数
     */
    apiMethod: {
      type: Function,
      default: () => (pageNum, pageSize) => { console.log(pageNum, pageSize); },
    },
    /**
     * api响应处理函数，(pageNum,pageSize):{isFinish?,totalCount?,list} => {}
     * 如果数据异常返回undefined即可
     */
    responseHandler: {
      type: Function,
      default: null,
    },
    errorText: {
      type: String,
      default: '获取数据出错，请点击重试',
    },
    finishedText: {
      type: String,
      default: '没有更多了~',
    },
    pageSize: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      pageNum: 0,
      isLoading: false,
      isError: false,
      isFinish: false,
      list: [],
    };
  },
  methods: {
    reset() {
      this.pageNum = 0;
      this.isLoading = false;
      this.isError = false;
      this.isFinish = false;
      this.list = [];
    },
    async request(count) {
      if (!this.isFinish) {
        try {
          this.isLoading = true;
          const res = await this.apiMethod(count, this.pageSize);
          const handler = this.responseHandler || this.defaultResponseHandler;
          const {
            isFinish, isFinished, totalCount, list,
          } = handler(res);
          this.pageNum = count;
          this.list = this.list.concat(list);
          if (typeof isFinished === 'boolean') {
            this.isFinish = isFinished;
          } else if (typeof isFinish === 'boolean') {
            this.isFinish = isFinish;
          } else {
            this.isFinish = this.list.length >= totalCount;
          }
          this.isError = false;
        } catch (error) {
          console.error(error);
          this.isError = true;
        } finally {
          this.isLoading = false;
        }
      }
    },
    defaultResponseHandler(res) {
      const { respCode, code, data } = res;
      if (respCode === STATUS.SUCCESS || code === STATUS.SUCCESS) {
        const { isFinished, totalCount, content = [] } = data;
        return { isFinish: isFinished, totalCount, list: content };
      } else {
        return undefined;
      }
    },
  },
};
</script>
